export function htmlPdf (data){
    data.sign = '${sign}';
    return `<!DOCTYPE html><html lang="en"><head><meta charset="UTF-8"><meta http-equiv="X-UA-Compatible"content="IE=edge"><meta name="viewport"content="width=device-width, initial-scale=1.0"><title>电子凭证</title><style>*,body,html{margin:0;padding:0}.box{width:800px;padding:32px 24px 24px}.title{font-size:24px;font-family:STSongti-SC-Bold,STSongti-SC;font-weight:bold;color:#333333;line-height:33px;text-align:center;margin-bottom:16px}.first-line{display:flex;justify-content:space-between;margin-bottom:12px}.label{font-size:16px;font-family:STSongti-SC-Regular,STSongti-SC;font-weight:400;color:#666666;line-height:25px}.content{font-size:16px;font-family:STSongti-SC-Regular,STSongti-SC;font-weight:400;color:#333333;line-height:25px}.table{width:100%;border:1px solid#333333}.item1{display:flex;padding:24px;box-sizing:border-box;border-bottom:1px solid#333333}.userName{margin-left:100px}.item2{padding:24px;box-sizing:border-box;border-bottom:1px solid#333333}.item3{display:flex;padding:24px;box-sizing:border-box;border-bottom:1px solid#333333}.money-big{margin-left:50px}.item4{display:flex}.order{margin-top:13px}.left{padding:48px 24px 48px;border-right:1px solid#333;width:50%}.right{padding:67px 24px 48px;width:50%}.sign{color:#fff;font-size:12px}</style></head><body><div class=box><p class=title>伟东凌鸿电子收款凭证</p><div class=first-line><p class=transactionNum><span class=label>唯一交易单号：</span><span class=content>${data.orderNo}</span></p><p class=transactionTime><span class=label>交易时间：</span><span class=content>${data.tradeTime || ''}</span></p></div><div class=table><div class=item1><p class=add><span class=label>今收到：</span><span class=content>${data.regionCodeStr} ${data.campusCodeStr} ${data.classTypeStr}</span></p><p class=userName><span class=label>姓名：</span><span class=content>${data.name}</span></p></div><div class=item2><span class=label>款项用途：</span><span class=content>伟东凌鸿专升本培训费</span></div><div class=item3><p class=money-small><span class=label>金额(小写)：</span><span class=content>¥${data.paymentAmount}元</span></p><p class=money-big><span class=label>金额(大写)：</span><span class=content>${convertCurrency(data.paymentAmount)}</span></p></div><div class=item4><div class=left><p class=fangshi><span class=label>支付方式：</span><span class=content>微信支付</span></p><p class=order><span class=label>支付单号：</span><span class=content>${data.externalOrderNo}</span></p></div><div class=right><span class=laebl>收款方：</span><span class=content>北京伟东凌鸿教育科技有限公司</span><span class=sign>${data.sign}</span></div></div></div></div></body></html>`
}
/*eslint-disable*/
// 人民币缓缓大写
export function convertCurrency(money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟');
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆');
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘');
  //整数金额时后面跟的字符
  var cnInteger = '整';
  //整型完以后的单位
  var cnIntLast = '元';
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  //金额整数部分
  var integerNum;
  //金额小数部分
  var decimalNum;
  //输出的中文金额字符串
  var chineseStr = '';
  //分离金额后用的数组，预定义
  var parts;
  if (money == '') { return ''; }
  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }
  //转换为字符串
  money = money.toString();
  if (money.indexOf('.') == -1) {
    integerNum = money;
    decimalNum = '';
  } else {
    parts = money.split('.');
    integerNum = parts[0];
    decimalNum = parts[1].substr(0, 4);
  }
  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '') {
    chineseStr += cnInteger;
  }
  return chineseStr;
}